// extracted by mini-css-extract-plugin
export var cartContainer = "_k1-4";
export var gray = "_k1-1";
export var itemContainer = "_k1-2";
export var itemDetails = "_k1-3";
export var strong = "_k1-0";